<form [formGroup]="subscriptionForm" class="stakeholder-search-form">
  <div class="input-row column-on-small">
    <mat-form-field appearance="outline">
      <mat-label for="LastName">Last Name</mat-label>
      <input
        matInput
        id="LastName"
        formControlName="LastName"
        aria-required="true"
        (input)="onInput()"
        (blur)="onBlur()"
        autocomplete="family-name"
        #lastNameInput
      />
      @if (subscriptionForm.controls['LastName'].invalid) {
        <mat-error id="lastNameError"> Last Name is required </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label for="ZipCode">Zip Code</mat-label>
      <input
        matInput
        id="Mail1ZipCode"
        formControlName="Mail1ZipCode"
        aria-required="true"
        (input)="onInput()"
        (blur)="onBlur()"
        autocomplete="postal-code"
        #zipCodeInput
      />
      @if (subscriptionForm.controls['Mail1ZipCode'].hasError('required')) {
        <mat-error id="mail1ZipCodeError"> Zip Code is required </mat-error>
      }
      @if (subscriptionForm.controls['Mail1ZipCode'].hasError('pattern')) {
        <mat-error id="mail1ZipCodeError"> Zip Code must be 5 digits </mat-error>
      }
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label for="Email">Email Address</mat-label>
    <input
      matInput
      id="StakeEmail"
      formControlName="StakeEmail"
      type="email"
      aria-required="true"
      (input)="onInput()"
      (blur)="onBlur()"
      autocomplete="email"
      #emailInput
    />
    @if (subscriptionForm.controls['StakeEmail'].hasError('required')) {
      <mat-error id="stakeEmailError"> Email Address is required </mat-error>
    }
    @if (
      subscriptionForm.controls['StakeEmail'].hasError('email') &&
      !subscriptionForm.controls['StakeEmail'].hasError('required')
    ) {
      <mat-error id="stakeEmailError"> Enter a valid email address </mat-error>
    }
  </mat-form-field>

  @if (isLoading) {
    <div class="loading" aria-live="polite">
      <p class="loading-text">Checking Database</p>
      <mat-progress-spinner mode="indeterminate" diameter="50" color="primary"></mat-progress-spinner>
      <app-dynamic-confirmation [wrapperClass]="'sr-only'"> Checking Database </app-dynamic-confirmation>
    </div>
  }
</form>
